import type { FormationSlot, PositionGroup } from '../types';

const slot = (id: string, label: string, x: number, y: number, allowed: PositionGroup[]): FormationSlot => ({ id, label, x, y, allowed });

export const formations: Record<string, FormationSlot[]> = {
  '4-2-3-1': [
    slot('gk', 'GK', 50, 91, ['GK']),
    slot('lb', 'LB', 15, 73, ['DEF']), slot('lcb', 'LCB', 38, 78, ['DEF']), slot('rcb', 'RCB', 62, 78, ['DEF']), slot('rb', 'RB', 85, 73, ['DEF']),
    slot('ldm', 'LDM', 38, 58, ['MID']), slot('rdm', 'RDM', 62, 58, ['MID']),
    slot('lw', 'LW', 18, 35, ['FWD', 'MID']), slot('cam', 'CAM', 50, 39, ['MID', 'FWD']), slot('rw', 'RW', 82, 35, ['FWD', 'MID']),
    slot('st', 'ST', 50, 15, ['FWD']),
  ],
  '4-3-3': [
    slot('gk', 'GK', 50, 91, ['GK']),
    slot('lb', 'LB', 15, 73, ['DEF']), slot('lcb', 'LCB', 38, 78, ['DEF']), slot('rcb', 'RCB', 62, 78, ['DEF']), slot('rb', 'RB', 85, 73, ['DEF']),
    slot('lcm', 'LCM', 30, 53, ['MID']), slot('dm', 'DM', 50, 61, ['MID']), slot('rcm', 'RCM', 70, 53, ['MID']),
    slot('lw', 'LW', 19, 25, ['FWD', 'MID']), slot('st', 'ST', 50, 15, ['FWD']), slot('rw', 'RW', 81, 25, ['FWD', 'MID']),
  ],
  '3-4-2-1': [
    slot('gk', 'GK', 50, 91, ['GK']),
    slot('lcb', 'LCB', 27, 76, ['DEF']), slot('cb', 'CB', 50, 80, ['DEF']), slot('rcb', 'RCB', 73, 76, ['DEF']),
    slot('lwb', 'LWB', 13, 51, ['DEF', 'MID']), slot('lcm', 'LCM', 39, 57, ['MID']), slot('rcm', 'RCM', 61, 57, ['MID']), slot('rwb', 'RWB', 87, 51, ['DEF', 'MID']),
    slot('lam', 'LAM', 35, 34, ['MID', 'FWD']), slot('ram', 'RAM', 65, 34, ['MID', 'FWD']),
    slot('st', 'ST', 50, 14, ['FWD']),
  ],
  '4-4-2': [
    slot('gk', 'GK', 50, 91, ['GK']),
    slot('lb', 'LB', 15, 73, ['DEF']), slot('lcb', 'LCB', 38, 78, ['DEF']), slot('rcb', 'RCB', 62, 78, ['DEF']), slot('rb', 'RB', 85, 73, ['DEF']),
    slot('lm', 'LM', 17, 48, ['MID', 'FWD']), slot('lcm', 'LCM', 39, 55, ['MID']), slot('rcm', 'RCM', 61, 55, ['MID']), slot('rm', 'RM', 83, 48, ['MID', 'FWD']),
    slot('lst', 'LST', 38, 20, ['FWD']), slot('rst', 'RST', 62, 20, ['FWD']),
  ],
};

export const defaultLineups: Record<string, string[]> = {
  '4-2-3-1': ['senne-lammens', 'patrick-dorgu', 'lisandro-martinez', 'leny-yoro', 'diogo-dalot', 'andrey-santos', 'youri-tielemans', 'matheus-cunha', 'bruno-fernandes', 'bryan-mbeumo', 'benjamin-sesko'],
  '4-3-3': ['senne-lammens', 'patrick-dorgu', 'lisandro-martinez', 'leny-yoro', 'diogo-dalot', 'andrey-santos', 'youri-tielemans', 'bruno-fernandes', 'matheus-cunha', 'benjamin-sesko', 'bryan-mbeumo'],
  '3-4-2-1': ['senne-lammens', 'lisandro-martinez', 'matthijs-de-ligt', 'leny-yoro', 'patrick-dorgu', 'andrey-santos', 'youri-tielemans', 'diogo-dalot', 'matheus-cunha', 'bruno-fernandes', 'benjamin-sesko'],
  '4-4-2': ['senne-lammens', 'patrick-dorgu', 'lisandro-martinez', 'leny-yoro', 'diogo-dalot', 'matheus-cunha', 'andrey-santos', 'youri-tielemans', 'bryan-mbeumo', 'benjamin-sesko', 'joshua-zirkzee'],
};
